<template>
  <div class="footer-get-the-app">
    <span class="title headline-l">{{ $t('layout.footer.getTheApp') }}</span>
    <div v-if="isQrShown" class="qr-code">
      <UiSmartImage
        :alt="$t('layout.footer.getTheApp')"
        :lazy-loading="true"
        :skeleton="true"
        :src-mobile="qrIcon?.srcMobile"
        :src="qrIcon?.src || ''"
        aspect-ratio="1/1"
        class="get-the-app-qr-icon icon"
      />
    </div>
    <div v-if="isIosButtonShown" class="ios">
      <UiSmartLink
        :to="iosUrlPath || ''"
        target="_blank"
        rel="noopener noreferrer"
      >
        <UiSmartImage
          :alt="$t('layout.footer.appStore')"
          :lazy-loading="true"
          :skeleton="true"
          :src-mobile="iosIcon?.srcMobile"
          :src="iosIcon?.src || ''"
          aspect-ratio="323/125"
          class="get-the-app-ios icon"
        />
      </UiSmartLink>
    </div>
    <div v-if="isAndroidButtonShown" class="android">
      <UiSmartLink
        :to="androidUrlPath || ''"
        target="_blank"
        rel="noopener noreferrer"
      >
        <UiSmartImage
          :alt="$t('layout.footer.googlePlay')"
          :lazy-loading="true"
          :skeleton="true"
          :src-mobile="androidIcon?.srcMobile"
          :src="androidIcon?.src || ''"
          aspect-ratio="323/125"
          class="get-the-app-android icon"
        />
      </UiSmartLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { GetTheAppDTO } from '~/types/api/bff/web/layout/layout.types'
import UiSmartImage from '@sephora-asia/ui-smart-image'
import UiSmartLink from '@sephora-asia/ui-smart-link'

const { isDesktopOrTablet, isIos, isAndroid } = useDevice()

const props = defineProps<GetTheAppDTO>()

const isQrShown = props.qrIcon?.src && isDesktopOrTablet

const isIosButtonShown =
  props.iosUrlPath &&
  props.iosIcon?.src &&
  props.iosIcon?.srcMobile &&
  (isDesktopOrTablet || isIos)

const isAndroidButtonShown =
  props.androidUrlPath &&
  props.androidIcon?.src &&
  props.androidIcon?.srcMobile &&
  (isDesktopOrTablet || isAndroid)
</script>

<style lang="scss" scoped>
.footer-get-the-app {
  display: inline-block;
  color: var(--color-base-white);

  .qr-code {
    margin-top: 8px;
    justify-content: center;

    .icon {
      height: 80px;
      display: flex;
    }
  }

  .ios {
    margin-top: 8px;
  }

  .ios,
  .android {
    .icon {
      height: 46px;
      display: flex;
    }
  }
}
</style>
